module.exports = __webpack_public_path__ + "img/comments-question.b4f19491.svg";